<template>
  <div :menu-fix="false">
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.factorySettlements'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="settleObjForm"
          :model="settleObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.title')">{{
                    settleObj.title
                  }}</el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('settlement.amount')">
                    {{ settleObj.settleAmount | currency }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.orderQuantity')">
                    {{ orders.length }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('settlement.searchCondition')">{{
                    settleObj.searchCondition
                  }}</el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.detail") }}
              </legend>
              <vxe-table
                :data="orders"
                ref="itemsTable"
                class="recordsTable"
                size="mini"
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="images"
                  :title="$t('product.images')"
                  width="85"
                >
                  <template v-slot="{ row }">
                    <thumbnail :images="row.images"></thumbnail>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="serialNo"
                  :title="$t('text.serialNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <small v-if="row.hurry" class="red">
                      ({{ $t("order.hurrySimple") }})
                    </small>
                    <s v-if="row.retrieveAt != null">{{ row.serialNo }}</s>

                    <span v-if="row.retrieveAt == null">
                      <s v-if="row.jyOrderCancelAt != null" class="grey">{{
                        row.serialNo
                      }}</s>
                      <span v-if="row.jyOrderCancelAt == null">{{
                        row.serialNo
                      }}</span>
                    </span>
                    <div v-if="row.innerSerialNo != null" class="font10">
                      {{ row.innerSerialNo }}
                    </div>
                    <div>
                      <state-label :state="row.workflowState">{{
                        $t("mesOrderStates." + row.workflowState)
                      }}</state-label>
                      <small v-if="row.pauseAt != null" class="orange">
                        {{ $t("text.stop") }}
                      </small>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="factoryName"
                  :title="$t('menu.factories')"
                  min-width="80"
                />
                <vxe-table-column
                  field="customerName"
                  :title="$t('menu.customers')"
                  min-width="90"
                >
                  <template v-slot="{ row }">
                    {{ row.customerName }}
                    <div class="font10">
                      {{ row.terminalCustomerName }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="productNo"
                  :title="$t('product.productNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.productNo }}
                    <div class="font10">{{ row.color }} {{ row.size }}</div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                  min-width="90"
                >
                  <template v-slot="{ row }">
                    {{ row.quantity }}{{ row.unit }}
                    <div class="font10">
                      {{ $t("phase.price") }}:{{ row.costPrice | currency }}
                    </div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="subTotal"
                  :title="$t('order.subtotal')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    {{ row.subTotal | currency }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  :title="$t('settlement.settleTotal')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <el-input
                      size="small"
                      v-model="row.factorySettleAmount"
                      width="100"
                      @blur="computeAmount"
                    />
                  </template>
                </vxe-table-column>

                <!-- <vxe-table-column
                  field="handOverAt"
                  :title="$t('text.handOverAt')"
                  min-width="150"
                /> -->
                <vxe-table-column :title="$t('text.handle')" min-width="80">
                  <template v-slot="{ row }">
                    {{ row.ownerName }}
                    <div class="font10">{{ row.handleDepart }}</div>
                  </template>
                </vxe-table-column>

                <vxe-table-column :title="$t('text.remark')" min-width="60">
                  <template v-slot="{ row }">
                    <raw-html-limit-number :content="row.remark" :number="6" />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="createAt"
                  :title="$t('text.createAt')"
                  min-width="130"
                >
                  <template v-slot="{ row }">
                    {{ row.createAt }}
                    <div class="font10">
                      {{ $t("text.handOverAt2") }}:{{ row.handOverAt }}
                    </div>
                    <div class="font10">
                      {{ $t("action.receive") }}:{{ row.finishedAt }}
                    </div>
                  </template>
                </vxe-table-column>

                <!-- <vxe-table-column
                  field="finishedAt"
                  :title="$t('dateTypesMes.finishedAt')"
                  min-width="110"
                /> -->
              </vxe-table>
            </fieldset>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
//
import OrderMes from "@/api/orderMes.js";
import Factory from "@/api/factory.js";
import Settlement from "@/api/settlement.js";

export default {
  mixins: [page],
  components: {
    BackButton,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      customer: null,
      orders: [],
      Util: Util,
      settleObj: {
        title: null,
        factoryIds: [],
        voucher: null,
        settle: false,
        settleAmount: null,
        searchCondition: null,
        orders: [],
        _productQuantity: null,
        _orderQuantity: null,
      },

      saveDoing: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    if (self.$route.query.createAtStartAt !== undefined) {
      self.settleObj.searchCondition =
        "创建日期:" +
        self.$route.query.createAtStartAt +
        "~" +
        self.$route.query.createAtEndAt;
    }

    if (self.$route.query.finishedAtStartAt !== undefined) {
      self.settleObj.searchCondition =
        "收货日期:" +
        self.$route.query.finishedAtStartAt +
        "~" +
        self.$route.query.finishedAtEndAt;
    }

    self.loadingStart();
    self.settleObj.title = self.$route.params.title;
    axios
      .all([Factory.findByTenantId(), OrderMes.unSettle(self.$route.query)])
      .then(
        axios.spread(function (factories, orders) {
          self.loadingEnd();
          if (factories.status === 200) {
            self.factories = factories.data;
            if (self.$route.query.factoryIds !== undefined) {
              const conditionFactories = self.factories.filter((f) =>
                self.$route.query.factoryIds.includes(f.id)
              );
              const conditionFactoriesName = conditionFactories.map(
                (f) => f.name
              );
              self.settleObj.searchCondition =
                self.settleObj.searchCondition +
                ",产线:" +
                conditionFactoriesName.join("、");
            }
          } else {
            self.sysError();
          }
          if (orders.status === 200) {
            self.orders = orders.data;
            for (const o of self.orders) {
              // Vue.set(o, "settleTotal", o.price * o.quantity + o.extraCharge);
              // Vue.set(o, "explain", null);
              Vue.set(
                o,
                "subTotal",
                Util.toFixed((o.quantity || 0) * (o.costPrice || 0), 3)
              );
              Vue.set(
                o,
                "factorySettleAmount",
                Util.toFixed((o.quantity || 0) * (o.costPrice || 0), 3)
              );
            }
            self.computeAmount();
          } else {
            self.sysError();
          }
        })
      );
  },

  methods: {
    remove(row, rowIndex) {
      this.orders.splice(rowIndex, 1);
      this.computeAmount();
    },
    computeAmount() {
      const self = this;
      self.settleObj.settleAmount = 0;
      self.settleObj.productQuantity = 0;
      for (const order of self.orders) {
        self.settleObj.settleAmount =
          Number(order.factorySettleAmount) + self.settleObj.settleAmount;
        self.settleObj._productQuantity =
          order.quantity + self.settleObj._productQuantity;
      }
      self.settleObj._orderQuantity = self.orders.length;
    },
    //
    saveSubmit() {
      let self = this;
      if (self.orders.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      for (const o of self.orders) {
        if (!Util.regexPrice(o.factorySettleAmount)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("settlement.settleTotal"),
            ]),
            type: "warning",
          });
          return;
        }
      }
      self.settleObj.orders = self.orders.map((o) => {
        return { uuid: o.uuid, factorySettleAmount: o.factorySettleAmount };
      });
      self.saveDoing = true;
      Settlement.createMes(self.settleObj).then(function (res) {
        self.saveDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.$router.push({ name: "fnReportsFactorySettlements" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>